
<div *ngIf="(hasMoveMoneyDataAccess) && isReactivatableProfile && (reactivateAchFlaggedOn$ | async)">
  <a (click)="actionClicked($event, params.reactivateProfile)">{{params.reactivateProfile}}</a>
  <span> | </span>
</div>

<div *ngIf="(hasMoveMoneyDataAccess || isEmployee || isDemoUser) && showStartTransactionLink && !(isRestrictedFlow$ | async)" data-testid="start_transaction_link">
  <a (click)="actionClicked($event, params.startTransaction)" id="start_transaction_link{{params.data.DraftId}}">{{params.startTransaction}}</a>
  <span> | </span>
</div>

<div *ngIf="showViewLink" >
  <a (click)="actionClicked($event, params.viewStatus)" data-testid= "view-link">{{viewReviewLink}}</a>
</div>

<div *ngIf="(hasMoveMoneyDataAccess || isEmployee || isDemoUser) && ((isEditableCheck)
  || (isEditableInternalTransfer)
  || (isEditableAch)) && !isInitiateAndReleaseFlow && !hidePaasbAchStandingAuthEdit">
  <span> | </span>
  <a (click)="actionClicked($event, params.edit)">{{params.edit}}</a>
</div>

<div *ngIf="(hasMoveMoneyDataAccess || isEmployee || isDemoUser) && isEditableProfile && !isInitiateAndReleaseFlow && !isPensionTrustAccount && !hidePaasbAchStandingAuthEdit" data-testid="view-editProfile">
  <span> | </span>
  <a (click)="actionClicked($event, params.editProfile)">{{params.editProfile}}</a>
</div>

<div *ngIf="(hasMoveMoneyDataAccess || isEmployee || isDemoUser) && (isTransactionCancelable)">
  <span> | </span>
  <a (click)="actionClicked($event, params.cancel)">{{params.cancel}}</a>
</div>

<div *ngIf="(hasMoveMoneyDataAccess || isEmployee) && isDeletableProfile">
  <span> | </span>
  <a (click)="actionClicked($event, params.deleteProfile)">{{params.deleteProfile}}</a>
</div>

<div *ngIf="(hasMoveMoneyDataAccess || isEmployee) && (isDeactivatableProfile)">
  <span> | </span>
  <a (click)="actionClicked($event, params.deactivateProfile)">{{params.deleteProfile}}</a>
</div>

<div *ngIf="isCancelableDraft">
  <span> | </span>
  <a (click)="actionClicked($event, params.cancel)">{{cancelDeleteLink}}</a>
</div>

<div *ngIf="isCreateRuleTable">
  <a (click)="actionClicked($event, params.delete)">{{params.delete}}</a>
</div>
